import * as React from 'react';
import WeekStartersEnum from '../enums/WeekStartersEnum';
import Actions from '../enums/ActionsEnum';
var WeeklyContext = React.createContext({
    setDatePickerIsShown: function () { },
    datePickerIsShown: false,
    rerenderTitleHandler: function () { },
    date: {},
    dateOnFocuse: '',
    calendarRef: {},
    handleMonthChange: function (start, end, timezone, isNextClicked) { },
    timezone: '',
    dates: {},
    isPrivateEventsShown: false,
    locale: 'en',
    weekStarter: WeekStartersEnum.Sunday,
    // recurrenceArr: [],
    firstDay: 0,
    calendarsList: [],
    privetEventsTitle: 'Private',
    isMobile: false,
    onEventExpanded: function () { },
    timeFormat: '',
    onCopyClick: function () { },
    onLocationClick: function () { },
    onAttachmentClick: function () { },
    experiments: [],
    action: Actions.NO_ACTION,
});
export default WeeklyContext;
//# sourceMappingURL=weeklyContext.js.map